"use client";
import Script from "next/script";
import { isProduction } from "@portal/app/_common/lib/edgeUtils";
import { retryScript } from "./RetryScript";

const trustedFormScriptId = "trusted-form-script";
const onLoad = () => {
  setTimeout(() => {
    if (!window.trustedForm) {
      retryScript(trustedFormScriptId);
    }
  }, 500);
};

export const TrustedFormScript = ({
  customerId,
  enabled,
}: {
  customerId: string;
  enabled: boolean;
}) =>
  enabled ? (
    <Script
      id={trustedFormScriptId}
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
(function() {
  var tf = document.createElement('script');
  var sandbox = ${!isProduction()};
  var identifier = '${customerId}';
  tf.type = 'text/javascript'; tf.async = true;
  tf.src = ("https:" == document.location.protocol ? 'https' : 'http') + "://api.trustedform.com/trustedform.js?sandbox=" + sandbox + "&identifier=" + identifier + "&field=xxTrustedFormCertUrl&use_tagged_consent=true&ping_field=xxTrustedFormPingUrl&l=" + new Date().getTime() + Math.random();
  var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s);
})();`,
      }}
      onLoad={onLoad}
      onError={() => retryScript(trustedFormScriptId, onLoad)}
    />
  ) : null;
